import { ChangeEvent } from "react";

import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import { modelPrefJobTypes } from "@/features/model/const/modelPrefJobTypes";
import {
  JobTypeEnum,
  ModelOrderByWithRelationInput,
  ModelWhereInput,
} from "@/generated/graphql-hooks";

export const ModelPrefJobTypeFilter = () => {
  const { query, setWhere } = useRequestQuery<
    ModelWhereInput,
    ModelOrderByWithRelationInput
  >();

  const onSetFilter = (e: ChangeEvent<HTMLInputElement>) => {
    const { prefJobType, ...rest } = query.where;

    if (!e.target.checked) {
      const newPrefJobType = prefJobType?.hasSome?.filter(
        (x) => x !== e.target.value,
      );

      setWhere({
        ...rest,
        ...(!!newPrefJobType?.length && {
          prefJobType: {
            hasSome: prefJobType.hasSome.filter((x) => x !== e.target.value),
          },
        }),
      });
      return;
    }

    setWhere({
      ...rest,
      prefJobType: {
        hasSome: [
          ...(prefJobType?.hasSome ?? []),
          e.target.value as JobTypeEnum,
        ],
      },
    });
  };

  return (
    <div className="space-y-3">
      {Object.entries(modelPrefJobTypes).map(([value, label], index) => (
        <label className="flex items-center space-x-3" key={index}>
          <input
            type="checkbox"
            name={label}
            value={value}
            checked={query?.where?.prefJobType?.hasSome?.includes(
              value as JobTypeEnum,
            )}
            className="form-checkbox text-primary h-4 w-4 rounded border-gray-500 bg-transparent !ring-0 !ring-offset-0"
            onChange={onSetFilter}
          />
          <span className="text-base font-light text-gray-900">{label}</span>
        </label>
      ))}
    </div>
  );
};
